/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { newReportBuilder, editReportBuilder } from './controller';


export default (router) => {
	router(`/report-builder/new`, newReportBuilder, makeLayout, render);
	router(`/report-builder/:reportId/edit`, editReportBuilder, makeLayout, render);
};
